import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Copy } from './copy';
const ProgressContainer = styled.div.withConfig({ displayName: "brc-sc-ProgressContainer", componentId: "brc-sc-bw3cus" }) `
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  align-items: center;
`;
const StepsProgressPill = styled.div.withConfig({ displayName: "brc-sc-StepsProgressPill", componentId: "brc-sc-1mprqw2" }) `
  background-color: ${({ FilledBgColor, EmptyBgColor, complete, theme }) => { var _a, _b; return complete ? (_a = theme[FilledBgColor]) !== null && _a !== void 0 ? _a : FilledBgColor : (_b = theme[EmptyBgColor]) !== null && _b !== void 0 ? _b : EmptyBgColor; }};

  height: 8px;
  width: 60px;
  border-radius: 10px;
`;
export const ProgressSteps = ({ steps, stepsComplete, FilledBgColor = 'navStatusPositive', EmptyBgColor = 'navNeutral100', className, }) => {
    return (_jsxs(ProgressContainer, { className: className, "data-testid": "progress-steps:container", children: [[...Array(steps)].map((_, i) => (_jsx(StepsProgressPill, { "data-testid": `progress-steps:step-${i + 1}`, FilledBgColor: FilledBgColor, EmptyBgColor: EmptyBgColor, complete: i < stepsComplete }, i))), _jsxs(Copy, { size: "sm", children: [stepsComplete, "/", steps, " Complete"] })] }));
};
//# sourceMappingURL=progress-steps.js.map